import styled, { css } from 'styled-components';

import { Box } from '@mui/material';

export const Wrapper = styled(Box)`
  ${({ theme }) => css`
    & + div {
      padding-top: ${theme.spacing(2)};
      border-top: 1px solid ${theme.yoga.colors.moduleBorder};
    }

    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(1)};
  `}
`;

export const Title = styled.h6`
  ${({ theme }) => css`
    font-size: ${theme.yoga.fontSizes.xsmall}px;
    font-weight: ${theme.yoga.fontWeights.medium};
    line-height: ${theme.yoga.lineHeights.xsmall}px;
    letter-spacing: 1px;
    text-transform: uppercase;

    max-width: fit-content;
  `}
`;
